import {Controller, useFormContext} from "react-hook-form";
import {FormField} from "../../../../../../../design-system/form-field";
import {Input, Space} from "antd";
import {SessionCurrencySelectFormField} from "./currency-select";
import {FormFieldError} from "../../../../../../../design-system/form-field";
import {SessionCurrenciesDefaultCallCurrencyFormFieldType} from "./types";

export function SessionCurrenciesDefaultCallCurrencyFormField({
  currencyOptions,
}: {
  currencyOptions: string[];
}) {
  const {control, formState} =
    useFormContext<SessionCurrenciesDefaultCallCurrencyFormFieldType>();

  const errorMessage = formState.errors.callPriceCurrency
    ? formState.errors.callPriceCurrency.message
    : formState.errors.callPrice?.message;
  return (
    <div>
      <FormField
        id="serviceDefaultPrice"
        label="Default price"
        renderInput={(id) => (
          <Controller
            control={control}
            name="callPrice"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <Space size={16} direction="vertical" style={{display: "flex"}}>
                <Input
                  id={id}
                  status={errorMessage ? "error" : ""}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="large"
                  value={value}
                  placeholder="Enter default price"
                  ref={ref}
                  addonBefore={
                    <SessionCurrencySelectFormField currencyOptions={currencyOptions} />
                  }
                />
                <FormFieldError errorMessage={errorMessage} />
              </Space>
            )}
          />
        )}
      />
    </div>
  );
}
